import axios from 'axios'

const api = axios.create({
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
  withCredentials: true,
  withXSRFToken: true,
})

const handlerDefaults = {
  onUnauthorized: null,
  onForbidden: null,
  onLocked: null,
  onMaintenance: null,
  onError: null,
}

let handlers = { ...handlerDefaults }

const buildContext = (error) => {
  const status = error?.response?.status ?? null
  const message = error?.response?.data?.message ?? null
  const url = error?.config?.url ?? null
  const requestConfig = error?.config ?? null

  return {
    status,
    message,
    url,
    requestConfig,
  }
}

const runHandler = async (handler, error, context) => {
  if (!handler) {
    return false
  }

  return await handler(error, context)
}

export const setApiHandlers = (nextHandlers = {}) => {
  handlers = { ...handlers, ...nextHandlers }
}

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const context = buildContext(error)

    if (context.status === 401 || context.status === 419) {
      if (context.message === 'CSRF token mismatch.') {
        location.reload()
        return
      }

      await runHandler(handlers.onUnauthorized, error, context)
    }

    if (context.status === 403) {
      await runHandler(handlers.onForbidden, error, context)
    }

    if (context.status === 423) {
      if (context.url === '/user/confirm-password') {
        return Promise.reject(error)
      }

      const confirmed = await runHandler(handlers.onLocked, error, context)

      if (confirmed && !error.config?._retryAfterConfirm) {
        const retryConfig = {
          ...error.config,
          _retryAfterConfirm: true,
        }

        return api.request(retryConfig)
      }
    }

    if (context.status === 503) {
      await runHandler(handlers.onMaintenance, error, context)
    }

    await runHandler(handlers.onError, error, context)

    return Promise.reject(error)
  }
)

export default api
